import { tv } from "../../variants/tv.js";
const TabsEmphasisVariants = {
    regular: {
        tab: 'hover:bg-primary-3 active:bg-primary-4 text-primary-13 data-disabled:hover:bg-transparent data-disabled:active:bg-transparent data-disabled:text-primary-6 focus-visible:inset-ring-actionPrimary-12',
        indicator: 'bg-primary-8',
        panel: 'focus-visible:border-primary-8'
    },
    medium: {
        tab: 'hover:bg-primary-3 active:bg-primary-4 text-primary-13 data-disabled:hover:bg-transparent data-disabled:active:bg-transparent data-disabled:text-primary-6 focus-visible:inset-ring-actionPrimary-12',
        indicator: 'bg-primary-8',
        panel: 'focus-visible:border-primary-8'
    }
};
const tabsEmphases = Object.keys(TabsEmphasisVariants);
const tabsVariants = tv({
    slots: {
        root: 'relative isolate',
        list: 'relative isolate flex w-full gap-1 overflow-x-auto pb-2',
        tab: 'focus-visible:inset-ring-offset-2 group flex cursor-pointer items-center justify-center rounded-lg px-3 py-2 select-none focus-visible:inset-ring-2 focus-visible:outline-none data-disabled:cursor-not-allowed',
        indicator: 'absolute bottom-0 left-0 -z-1 h-1 w-[var(--active-tab-width)] translate-x-[var(--active-tab-left)] -translate-y-1/2 rounded-sm transition duration-200 ease-in-out',
        panel: 'focus-visible:border focus-visible:outline-none',
        tabLabelContent: 'flex flex-col items-start justify-center text-left',
        icon: ''
    },
    variants: {
        emphasis: TabsEmphasisVariants,
        stacked: {
            true: {
                root: '@container w-full',
                tab: 'gap-0 @max-3xl:flex-col @max-3xl:px-2 @min-3xl:flex-row',
                icon: 'size-8 @min-3xl:mr-2'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        emphasis: 'regular',
        stacked: false
    }
});
export { TabsEmphasisVariants, tabsEmphases, tabsVariants };
